// extracted by mini-css-extract-plugin
module.exports = {"separation":"PlanningModalSeparation_separation__2DS7R"};